import { 
  MessageSquare, 
  ShoppingCart, 
  Package, 
  FileText, 
  BarChart3, 
  Zap,
  Bot,
  Smartphone,
  CreditCard,
  Users,
  Warehouse,
  Globe,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const features = [
  {
    icon: Bot,
    title: 'AI WhatsApp Assistant',
    description: 'Automatically respond to customer queries, take orders, and provide support 24/7 with our intelligent AI.',
    color: 'text-blue-500 bg-blue-500/10',
  },
  {
    icon: ShoppingCart,
    title: 'Smart POS System',
    description: 'Process sales quickly with our intuitive point-of-sale interface, optimized for tablets and desktops.',
    color: 'text-green-500 bg-green-500/10',
  },
  {
    icon: Package,
    title: 'Product Catalog',
    description: 'Manage your entire product catalog with categories, variants, images, and pricing in one place.',
    color: 'text-purple-500 bg-purple-500/10',
  },
  {
    icon: Warehouse,
    title: 'Inventory Tracking',
    description: 'Real-time stock levels, low stock alerts, and automatic reorder points to never miss a sale.',
    color: 'text-orange-500 bg-orange-500/10',
  },
  {
    icon: FileText,
    title: 'GST Invoicing',
    description: 'Generate professional GST-compliant invoices automatically and send them via WhatsApp.',
    color: 'text-indigo-500 bg-indigo-500/10',
  },
  {
    icon: BarChart3,
    title: 'Analytics & Reports',
    description: 'Understand your business with detailed reports on sales, customers, and AI performance.',
    color: 'text-pink-500 bg-pink-500/10',
  },
  {
    icon: Users,
    title: 'Customer Management',
    description: 'Build customer profiles, track purchase history, and segment for targeted marketing.',
    color: 'text-cyan-500 bg-cyan-500/10',
  },
  {
    icon: Zap,
    title: 'Automations',
    description: 'Set up automated workflows for order confirmations, follow-ups, and review requests.',
    color: 'text-yellow-500 bg-yellow-500/10',
  },
];

export function FeatureGrid() {
  return (
    <section className="py-20 lg:py-32 bg-muted/30" id="features">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Everything You Need to{' '}
            <span className="gradient-text">Sell on WhatsApp</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            From AI-powered conversations to inventory management, SparkCommerce has all the tools 
            you need to run a successful WhatsApp commerce business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className="group p-6 rounded-2xl bg-card border border-border hover:border-primary/50 hover:shadow-lg transition-all duration-300"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className={cn(
                  'w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110',
                  feature.color
                )}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-semibold mb-2">{feature.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
